import PageCustom from "../../components/PageCustom";
import React, {useEffect, useState} from "react"
import LoadPage from "../../components/LoadPage";
import Grid from "@material-ui/core/Grid";
import PlatformRequest from "../../utils/PlatformRequest";
import {Button, Checkbox, makeStyles, TableCell, TableRow, TextField, Typography} from "@material-ui/core";
import CustomTable from "../../components/CustomTable";
import {DeleteOutline} from "@material-ui/icons";
import Paper from "@material-ui/core/Paper";
import InputMask from 'react-input-mask';
import AlertMessage from "../../components/AlertMessage";
import ConfirmDialog from "../../components/ConfirmDialog";

const employeeDefault = {
    name: "",
    phone: "",
}

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(3),
        textAlign: 'center'
    },
}))

const EmployeePage = () => {
    const classes = useStyles()
    const [load, setLoad] = useState(false)
    const [providerEmployeeList, setProviderEmployeeList] = useState([])
    const [newEmployee, setNewEmployee] = useState(employeeDefault)
    const [openConfirm, setOpenConfirm] = useState(false)
    const [openDelete, setOpenDelete] = useState(false)
    const [selectedEmployee, setSelectedEmployee] = useState(null)
    const [alert, setAlert] = React.useState({
        severity: '',
        open: false,
        message: ''
    })

    useEffect(() => {
        loadEmployeeList()
    }, []);

    const loadEmployeeList = () => {
        setLoad(true)
        PlatformRequest.getProviderEmployee()
            .then((response) => {
                const {body} = response
                setProviderEmployeeList(body)
            })
            .catch(() => {
            })
            .finally(() => setLoad(false))
    }

    const getPhoneWithMask = (phone) => {
        const onlyNumbers = phone.replace(/\D/g, '');
        return onlyNumbers.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
    }

    const getPhoneWithoutMask = (phone) => {
        const onlyNumbers = phone.replace(/\D/g, '');
        return onlyNumbers.replace(/\D/g, '')
    }

    const changeNewEmployee = (key, value) => {
        setNewEmployee({...newEmployee, [key]: value})
    }

    const showAlert = (severity, message) => {
        setAlert({severity: severity, message: message, open: true});
        setTimeout(() => {
            setAlert({...alert, open: false})
        }, 5000);
    }

    const validateNewEmployee = () => {
        const {phone, name} = newEmployee
        const phoneNumber = getPhoneWithoutMask(phone)

        if (name === "" || phoneNumber === "") {
            showAlert("error", "Necessário informar o nome e o Whatsapp do funcionário")
            return
        }

        if (phoneNumber.length < 10) {
            showAlert("warning", "Por favor informe o número com DDD")
            return
        }

        setNewEmployee({...newEmployee, phone: phoneNumber})
        setOpenConfirm(true)
    }

    const deleteEmployee = (employee) => {
        const {id} = employee
        setLoad(true)
        PlatformRequest.deleteEmployee(id)
            .then(() => {
                const list = providerEmployeeList.filter((item) => item.id !== id)
                setProviderEmployeeList(list)
            })
            .catch(() => {
                showAlert("error", "Não foi possível excluir o funcionário")
            })
            .finally(() => setLoad(false))
    }

    const registerNewEmployee = () => {
        const body = {
            "name": newEmployee.name,
            "phone": newEmployee.phone
        }

        setLoad(true)
        PlatformRequest.createEmployee(body)
            .then((response) => {
                window.location.reload()
                console.log("response: ", response)
            })
            .catch((error) => {
                const json = JSON.stringify(error)
                const errorParse = JSON.parse(json)
                const {response} = errorParse
                const {status, body} = response
                if (status === 409) {
                    const {message} = body
                    showAlert("warning", message)
                }
            })
            .finally(() => setLoad(false))
    }

    const lockUnlockEmployee = (employee) => {
        const {blocked, id} = employee
        const body = {
            "block": !blocked
        }
        setLoad(true)
        PlatformRequest.lockUnlockEmployee(id, body)
            .then((response) => {
            })
            .catch((error) => {
                showAlert("Não foi possível realizar a operação")
            })
            .finally(() => setLoad(false))
    }

    return (
        <PageCustom title={"Funcionários"}>
            <LoadPage load={load}/>
            <AlertMessage severity={alert.severity} message={alert.message} open={alert.open}/>

            {selectedEmployee && (
                <ConfirmDialog
                    title="Deseja excluir o funcionário?"
                    open={openDelete}
                    callBackOpen={(value) => setOpenDelete(value)}
                    tooltip="Excluir"
                    description={
                        <p>
                            Após a confirmação, o usuário será removido. No entanto, as buscas que
                            ele respondeu permanecerão ativas e continuarão vinculadas ao seu
                            cadastro.
                        </p>
                    }
                    textConfirm="Sim, desejo excluir"
                    textBack="Voltar"
                    yesButtonAction={() => {
                        deleteEmployee(selectedEmployee);
                    }}
                />
            )}

            <br/>
            <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={2}>
                <Grid item xs={12} sm={12} md={12} lg={8}>
                    <Typography gutterBottom>
                        Meus Funcionários
                    </Typography>
                    <CustomTable
                        title={["Nome", "Telefone", "Ativo", "Ações"]}
                        items={providerEmployeeList.map((employee) => (
                            <TableRow key={employee.id} hover>
                                <TableCell align="left">{employee.name}</TableCell>
                                <TableCell align="left">{getPhoneWithMask(employee.phone)}</TableCell>
                                <TableCell align="left">
                                    <Checkbox
                                        defaultChecked={!employee.blocked}
                                        onChange={() => lockUnlockEmployee(employee)}
                                        color="primary"
                                        inputProps={{'aria-label': 'secondary checkbox'}}
                                    />
                                </TableCell>
                                <TableCell align="left">
                                    <Grid container spacing={1}>
                                        <Grid item>
                                            <Button
                                                fullWidth
                                                variant={"contained"}
                                                color={"primary"}
                                                onClick={() => {
                                                    setSelectedEmployee(employee);
                                                    setOpenDelete(true);
                                                }}
                                            >
                                                <DeleteOutline/>
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </TableCell>
                            </TableRow>
                        ))}
                    />
                </Grid>

                <Grid item lg={4}>
                    <Typography gutterBottom>
                        Cadastrar Novo Funcionário
                    </Typography>
                    <Paper className={classes.paper}>
                        <Grid container direction="row" alignItems="center" justify="center" spacing={1}>
                            <Grid item xs={12} md={12} lg={12}>
                                <TextField
                                    variant="outlined"
                                    margin="normal"
                                    required
                                    autoFocus
                                    fullWidth
                                    id="name"
                                    label="Nome"
                                    name="name"
                                    value={newEmployee.name}
                                    onChange={(e) => changeNewEmployee("name", e.target.value)}
                                />
                                <InputMask
                                    mask="(99) 99999-9999"
                                    value={newEmployee.phone}
                                    maskChar={null}
                                    onChange={(e) => changeNewEmployee("phone", e.target.value)}
                                >
                                    {(inputProps) => (
                                        <TextField
                                            {...inputProps}
                                            variant="outlined"
                                            margin="normal"
                                            required
                                            helperText="Esse será o login de acesso"
                                            fullWidth
                                            id="phone"
                                            label="Whatsapp"
                                            name="phone"
                                        />
                                    )}
                                </InputMask>
                            </Grid>

                            <Grid item xs={12} md={12} lg={12}>
                                <ConfirmDialog
                                    title="Deseja cadastrar um novo funcionário?"
                                    customButton={
                                        <Button
                                            fullWidth
                                            variant={"contained"}
                                            color={"secondary"}
                                            onClick={validateNewEmployee}>
                                            Cadastrar
                                        </Button>
                                    }
                                    callBackOpen={(value) => setOpenConfirm(value)}
                                    tooltip={"Cadastrar Novo Funcionário"}
                                    description={
                                        <p>
                                            Após confirmar, enviaremos ao funcionário uma mensagem via WhatsApp com suas
                                            credenciais de acesso. Oriente
                                            o funcionário a redefinir sua senha na opção 'Esqueci minha senha' na tela
                                            de login.
                                            <br/><br/>
                                            Nome: {newEmployee.name} <br/>
                                            Whatsapp: {newEmployee.phone}
                                        </p>
                                    }
                                    open={openConfirm}
                                    textConfirm="Sim, desejo cadastrar"
                                    textBack="Voltar"
                                    yesButtonAction={registerNewEmployee}
                                />
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>


        </PageCustom>
    )

}

export default EmployeePage